import React, { Fragment } from "react";
import moment from "moment";
import StringToJSX from "../../../functions/StringToJsx";
import {populateTemplate} from "../../../functions/PopulateTemplate";

const prepareLines = (lines) => {

  if (lines && Array.isArray(lines)) {
    lines.forEach(line => {
      line["arrivalDate"] = moment(line.arrivalDate).format("YYYY-MM-DD");
      line["departureDate"] = moment(line.departureDate).format("YYYY-MM-DD");
    })
  }
  return lines;
}

const OrderView = (props) => {
  const order = props.order;
  const lines = prepareLines(order?.lines||[]);

  return (
    <Fragment>
      <StringToJSX domString={populateTemplate(order.orderTemplate, order, lines)}/>
    </Fragment>
  );
}

export default OrderView;
